"use client";

import { ArrowRight } from "lucide-react";
import { usePathname } from "@/i18n/navigation";
import { PressAnnouncementPopup } from "./PressAnnouncementPopup";
import styles from "./PressAnnouncement.module.css";

export function PressAnnouncement({ is_signed_in }: { is_signed_in: boolean }) {
	const pathname = usePathname();
	const eligible =
		pathname === "/" || pathname.startsWith("/who-we-help/") || pathname.startsWith("/how-we-help/") || pathname.startsWith("/about/");

	if (is_signed_in || !eligible || pathname.startsWith("/about/news/studystash-joins-kortext")) return null;

	return (
		<aside
			aria-label="Latest news"
			className={styles.banner}
		>
			<PressAnnouncementPopup key={pathname}>
				<button
					type="button"
					className={styles.link}
				>
					<span className={styles.badge}>News</span>
					<span className={styles.message}>StudyStash joins Kortext.</span>
					<span className={styles.cta}>
						Read the announcement{" "}
						<ArrowRight
							size={16}
							aria-hidden="true"
						/>
					</span>
				</button>
			</PressAnnouncementPopup>
		</aside>
	);
}
